import styled from "styled-components";

export const Container = styled.div`
	background-color: #ffffff;
	height: 636px;
	width: 722px;
	border-radius: 30px;
	place-content: center;
	color: black;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
	position: relative;

	svg {
		margin-bottom: 4rem;
	}

	.close {
		width: 21px;

		position: absolute;
		right: 1.5rem;
		top: 1.5rem;

		cursor: pointer;
	}

	.divText {
		width: 65%;
		margin-bottom: 2rem;
	}

	.text {
		color: #b3b3b3;
		font-weight: 500;
		font-family: Roboto;
		font-size: 26px;
		line-height: 30.47px;
		text-align: center;
	}

	.textSecundary {
		color: #b3b3b3;
		font-weight: 500;
		font-family: Roboto;
		font-size: 24px;
		line-height: 30.47px;
		text-align: center;
	}

	.item {
		display: flex;
		margin: 1rem 0;

		img {
			margin-right: 1rem;
		}
	}

	.group {
		margin-bottom: 1rem;
	}
`;
